import * as React from "react";
import Button from "../button/button";

interface CustomCardProps {
  imageSrc: string;
  imageAlt: string;
  buttonText: string;
  backgroundColor?: string;
  onClick?: () => void;
}

const CustomCard: React.FC<CustomCardProps> = ({
  imageSrc,
  imageAlt,
  buttonText,
  backgroundColor = "bg-bluePrimary",
  onClick = () => {},
}) => {
  return (
    <div
      className={`${backgroundColor} rounded-2xl p-4 flex flex-col items-center`}
    >
      <img src={imageSrc} alt={imageAlt} className="w-12 h-12 mb-4" />
      <Button
        buttonType="account"
        className="w-full text-center mt-2"
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default CustomCard;
